import React, { useState } from 'react'
import { Row, Col, Form, Button, Container } from 'react-bootstrap'

const ContactForm = () => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [text, setText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("yep", name,email,subject,text);
  }

  return (
    <Container className='mt-5'>
      <Row className='gy-4'>
        <Col lg={9} md={8} sm={12} >
          <h1 className='display-6 text-black-50'>Feel free to contact us about anything 24/7 <span className='text-info'>!</span></h1>
          <Form onSubmit={(e) => handleSubmit(e)}>

            <Form.Group className="mb-3" controlId="formFullName">
              <Form.Label>Name and Surname</Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setName(e.target.value)} required type="name" placeholder="Enter Name" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setEmail(e.target.value)} required type="email" placeholder="Enter email" />
              <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formSubject">
              <Form.Label>Subject</Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setSubject(e.target.value)} required type="text" placeholder="Enter subject" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formText">
              <Form.Label></Form.Label>
              <Form.Control className='py-2 px-3 fs-5' onChange={(e) => setText(e.target.value)} required as="textarea" rows={3} />
            </Form.Group>

            <Button disabled={name===""||email===""||subject===""||text===""} className='py-2 w-sm-100 px-5 mt-3 fs-4' variant="outline-dark" type="submit">
              Submit
            </Button>
          </Form>
        </Col>
        <Col className='lead' lg={3} md={4}  sm={12} >
          <div className='mb-5'>
            <h2 className='fs-3 fw-thin text-black-50 underline'>Main Office<span className='text-info'>.</span></h2>
            <p>+555 555 5555 5555</p>
            <p>hqcontact@turquoise.com</p>
          </div>
          <div className='my-5'>
            <h2 className='fs-3 fw-thin text-black-50'>Return Information<span className='text-info'>.</span></h2>
            <p>+555 555 5555 5555</p>
            <p>return@turquoise.com</p>
          </div>
          <div className='my-5'>
            <h2 className='fs-3 fw-thin text-black-50'>Information<span className='text-info'>.</span></h2>
            <p>+555 555 5555 5555</p>
            <p>info@turquoise.com</p>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default ContactForm  